require('./blocks/reviews_about/reviews_about.less');
require('./blocks/impromptu/impromptu-review');
require('./blocks/reviews/reviews.less');
require('./blocks/icon-menu/icon-menu.less');
require('./blocks/icon-menu/icon-menu');
require('./blocks/review.less');
require('./blocks/pagination.less');
require('./blocks/reviews_about/reviews_about');
require('./blocks/styled-select/styled-select.less');



// WEBPACK FOOTER //
// ./reviews_about.js